import { request } from "#/utils/request";
import { Veiculo } from "#/types";

/** Endpoints */
export const ENDPOINT_BASE_VEICULOS = "/veiculos";

/**
 * @function buscarModelosPelaPlacaChassi - GET Vechicle Models
 * @param placa - placa do veiculo
 */
export const buscarModelosPelaPlacaChassi = async (params: {
  placa?: string;
  chassi?: string;
}) =>
  (
    await request.get<Veiculo[]>(`${ENDPOINT_BASE_VEICULOS}`, {
      params,
    })
  ).data;
